<script>
import Hsylcer from '../index';
export default {
  extends: Hsylcer,
  methods: {
    async initPermission() {
      this.$login.teacherPermitted();
    }
  }
};
</script>
